import React, { Component } from 'react';

class CheckoutTotal extends Component {
  render() {
    const { cartTotal } = this.props.value;
    return (
      <div>
        <p className='bold checkout__total'>Total: ${cartTotal.toFixed(2)}</p>
      </div>
    );
  }
}

export default CheckoutTotal;
